import { swapMyDillardsButtons } from './_swapMyDillardsButtons';

export const addAllInterestItemsToBag = (form, selector) => {
	var AddWishlistToBagForm = $(form).serialize();
	$.ajax({
		type: 'POST',
		url: 'OrderItemAdd',
		data: AddWishlistToBagForm,
		dataType: 'html',
		beforeSend: function () {
			$('.wishList').removeClass('active');
			$('.wishListPanel').removeClass('activePanel');
			$('#shoppingBagContainer').empty();
			$('#wishListContainer').empty();
			$('.shoppingBag').addClass('active');
			$('.shoppingBagPanel').addClass('activePanel');
			$('#myDillardsRightFrameContent .ajaxBigLoader').stop().fadeIn(350);
		},
		success: function () {
			$('.focused-btn').removeClass('focused-btn');
			swapMyDillardsButtons('#shoppingBag');
		},
		error: function (XMLHttpRequest, textStatus, errorThrown) {},
	});
};
